<div class="child">
    <router-outlet></router-outlet>
</div>
